import moment from "moment";

import { ChartRangeType } from "../constants";

export const getChartBarLabel = (
  label: string,
  date: Date,
  rangeType: ChartRangeType
): string | string[] => {
  switch (rangeType) {
    case ChartRangeType.Week:
      return getDateOfWeekByDay(date, label);
    case ChartRangeType.Month:
      return `${label} ${moment(date).format("MMM, YYYY")}`;
    case ChartRangeType.Year:
      return `${label}, ${moment(date).format("YYYY")}`;
    case ChartRangeType.Custom:
      return `${moment(label, "DD.MM.YY").format("DD MMM, YYYY")}`;
    default:
      return `${label}`;
  }
};

function getDateOfWeekByDay(date: Date, targetDayOfWeek: string) {
  const startDate = moment(date);

  const daysOfWeek = Array.from({ length: 7 }, (_, i) =>
    moment().weekday(i).format("ddd")
  );
  const targetDayIndex = daysOfWeek.indexOf(targetDayOfWeek);
  if (targetDayIndex === -1) {
    throw new Error("Invalid day name");
  }

  const currentDayIndex = startDate.day();

  const daysToAdd = targetDayIndex + 1 - currentDayIndex;

  return startDate.add(daysToAdd, "day").format("DD MMM, YYYY");
}
